<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ Object.entries(temp).length === 0 ? 'Agregar nueva' : 'Editar' }} marca</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit">
          <!-- Titulo -->
          <validation-provider #default="{ errors }" name="name" rules="requeridoE">
            <b-form-group label="Nombre" label-for="nombre">
              <b-form-input
                id="nombre"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Nombre"
                v-model="items.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ Object.entries(temp).length === 0 ? 'Agregar' : 'Actualizar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AutoPartsService from '@/services/AutoParts'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        name: '',
      },
      temp: {}
    }
  },
  methods: {
    resetForm() {
      this.$refs.refFormObserver.reset()
      // this.speciality.title = ''
    },
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items
        this.items = items
        this.isEdit = true
      } else {
        this.isEdit = false
        this.temp = {}
        this.items = {
          name: '',
        }
      }
      console.log('temp EN ADD', this.temp)
    },
    onSubmit() {
      console.log('data', this.items)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          if (this.isEdit == false) {
            resp = await AutoPartsService.saveAutoPartCategory(this.items, this.$store)
          } else {
            let datos = {
              name: this.items.name,
            }
            console.log('datos',datos)
            resp = await AutoPartsService.updateAutoPartCategory(this.items.id, datos, this.$store)
          }
          console.log('resp',resp)
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'La categoría ha sido ' + (this.isEdit == true ? 'actualizada.' : 'registrada.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            console.log('this.$parent.$parent', this.$parent.$parent)
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' la categoría',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
          console.log('no validado')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
